"use client";

import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

import { useCarePlanContext } from "./care-plan";

/** Provider Notes textarea with read-only gating. */
export function ProviderNotesField() {
  const {
    state: { selectedStep },
    actions: { updateStep },
    config: { readOnly },
  } = useCarePlanContext();

  if (!selectedStep) return null;

  const hasNotes = !!selectedStep.description?.trim();
  if (readOnly && !hasNotes) return null;

  return (
    <div className="space-y-1">
      <Label>Provider Notes</Label>
      <Textarea
        placeholder="Guidance for the provider at this step..."
        value={selectedStep.description ?? ""}
        onChange={(e) =>
          updateStep(selectedStep.id, { description: e.target.value })
        }
        disabled={readOnly}
        rows={3}
      />
    </div>
  );
}
